/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ProposalMatching from './ProposalMatching';

/**
 * The ProposalMatchingListResponse model module.
 * @module model/ProposalMatchingListResponse
 * @version 1.0.0
 */
class ProposalMatchingListResponse {
    /**
     * Constructs a new <code>ProposalMatchingListResponse</code>.
     * @alias module:model/ProposalMatchingListResponse
     */
    constructor() { 
        
        ProposalMatchingListResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProposalMatchingListResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProposalMatchingListResponse} obj Optional instance to populate.
     * @return {module:model/ProposalMatchingListResponse} The populated <code>ProposalMatchingListResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProposalMatchingListResponse();

            if (data.hasOwnProperty('proposal_matchings')) {
                obj['proposal_matchings'] = ApiClient.convertToType(data['proposal_matchings'], [ProposalMatching]);
            }
            if (data.hasOwnProperty('total_count')) {
                obj['total_count'] = ApiClient.convertToType(data['total_count'], 'Number');
            }
            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProposalMatchingListResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProposalMatchingListResponse</code>.
     */
    static validateJSON(data) {
        if (data['proposal_matchings']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['proposal_matchings'])) {
                throw new Error("Expected the field `proposal_matchings` to be an array in the JSON data but got " + data['proposal_matchings']);
            }
            // validate the optional field `proposal_matchings` (array)
            for (const item of data['proposal_matchings']) {
                ProposalMatching.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/ProposalMatching>} proposal_matchings
 */
ProposalMatchingListResponse.prototype['proposal_matchings'] = undefined;

/**
 * 総件数
 * @member {Number} total_count
 */
ProposalMatchingListResponse.prototype['total_count'] = undefined;

/**
 * 現在のページ
 * @member {Number} current_page
 */
ProposalMatchingListResponse.prototype['current_page'] = undefined;

/**
 * 1ページあたりの件数
 * @member {Number} per_page
 */
ProposalMatchingListResponse.prototype['per_page'] = undefined;






export default ProposalMatchingListResponse;

